<template>
  <el-dialog
    :lock-scroll="false"
    :visible="uploadPhotoDialogVisible"
    @close="onCancleBtn"
    :close-on-click-modal="false"
    title="上传"
  >
    <section class="upload-photo">
      <div class="photos-content">
        <div class="photos">
          <span v-for="(item, index) in photos" :key="item">
            <img :src="item" />
            <span class="operation">
              <i class="el-icon-zoom-in" @click="enlargeImage(item)"></i>
              <i class="el-icon-delete" @click="del(index)"></i>
            </span>
          </span>
        </div>
        <p class="upload-tip">
          备注：最多可上传两张图片，如需修改图片，请先删除原有图片，再上传。
        </p>
        <div class="button-group">
          <el-button type="primary" @click="onConfirmBtn">确 定</el-button>
          <el-button @click="onCancleBtn">取 消</el-button>
        </div>
      </div>
      <el-upload
        class="avatar-uploader"
        :action="'/img/oss/upload'"
        :show-file-list="false"
        :data="{ pathName: 'weili' }"
        :on-success="handleAvatarSuccess"
        :before-upload="checkPhotosNum"
      >
        <i class="el-icon-plus avatar-uploader-icon"></i>
      </el-upload>
      <el-image-viewer
        v-if="enlargeImageVisible"
        :on-close="closeImgViewer"
        :url-list="dialogImageUrl"
      >
      </el-image-viewer>
    </section>
  </el-dialog>
</template>
<script>
import { uploadParkingOrdersPhoto } from "@/api/url";
import elImageViewer from "element-ui/packages/image/src/image-viewer";
export default {
  props: {
    uploadPhotoDialogVisible: {
      type: Boolean,
      default: false,
    },
    oneOrder: {
      type: Object,
      default: {},
    },
  },
  data() {
    return {
      photos: [],
      enlargeImageVisible: false,
      dialogImageUrl: [],
    };
  },
  components: {
    elImageViewer,
  },
  computed: {
    photoArray: {
      get() {
        return this.oneOrder.pics;
      },
    },
  },
  watch: {
    photoArray: {
      handler(val) {
        this.photos = val;
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    handleRemove(file) {
   
    },

    onConfirmBtn() {
     
      if (this.photos.length <= 0) {
        this.$message.error("暂无照片可上传");
        return;
      }
    
      this.$postRequest(uploadParkingOrdersPhoto(), {
        orderId: this.oneOrder.orderId,
        pics: this.photos.toString(),
      }).then((data) => {
        const { status } = data;
        if (status === 200) {
          this.$emit("func", "success");
          this.$message({
            type: "success",
            message: "上传成功",
          });
        } else {
          this.$message.error(data.message);
        }
      });
    },
    onCancleBtn() {
      this.$emit("func");
    },
    del(index) {
      this.photos.splice(index, 1);
    },
    enlargeImage(url) {
      this.enlargeImageVisible = true;
      this.dialogImageUrl = url ? [url] : [];
    },
    closeImgViewer() {
      this.enlargeImageVisible = false;
    },
    checkPhotosNum() {
      if (this.photos.length >= 2) {
        this.$message({
          type: "warning",
          message: "上传图片不能超过两张",
        });
        return false;
      }
    },
    handleAvatarSuccess(response,file,fileList){
   
      if(response.status===200){
        this.photos=[...this.photos,response.data]
     
      }
    }
  },
};
</script>
<style scoped lang="scss">
.upload-photo {
  display: flex;
  justify-content: space-around;
  .photos-content {
    width: 70%;
    border: 1px dashed #ccc;
    border-radius: 10px;
    box-sizing: border-box;
    padding: 10px;
    .photos {
      width: 100%;
      display: flex;
      justify-content: flex-start;
      flex-wrap: wrap;
      margin-right: 20px;
      box-sizing: border-box;
      padding-bottom: 10px;
      span {
        overflow: hidden;
        box-sizing: border-box;
        padding: 7px;
        img {
          display: block;
          width: 120px;
          height: 120px;
          border-radius: 10px;
        }
        .operation {
          display: flex;
          justify-content: space-around;
          color: #278cd8;
          font-weight: bold;
          .el-icon-delete {
            // display: block;
            text-align: right;
            cursor: pointer;
          }
          .el-icon-zoom-in {
            cursor: pointer;
          }
        }
      }
    }
    .upload-tip {
      color: red;
      padding-bottom: 10px;
    }
    .button-group {
      display: flex;
      justify-content: center;
    }
  }
}
</style>
<style>
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 264px;
  line-height: 264px;
  text-align: center;
}
</style>
